import { useState, useEffect, useRef } from "react";
import { Card, Flex, Button, Row, Col, ConfigProvider, Checkbox } from "antd";
import * as _ from "@antv/util";
import ItemsTable from "./ItemsTable";
import useRemoveImage from "../../functions/Image/removeImage";
import useUpdatePlateItems from "../../functions/ItemDetails/updatePlateItems";
import formatCurrency from "../../functions/Common/formatCurrency";

const PLATE = {
  image_id: null,
  ai_image_data: null,
  items: [],
};

export default function SummaryCard(props) {
  const {
    plates,
    setPlates,
    itemDetailsCardRef,
    selectedPlateIndex,
    setSelectedPlateIndex,
    setActiveTabKey,
    selectedItemKey,
    setSelectedItemKey,
    setIsShowPayment,
    isDisableButton,
    setIsDisableButton,
    receiptPrice,
    setReceiptPrice,
    sstInfo,
    setSelectedSubCategory,
    setExtraChargesOptions,
    extraChangesOptions,
    extraCharges,
  } = props;

  const gridRef = useRef();
  const tableRef = useRef();

  const [tableRefState, setTableRefState] = useState(false);
  const [newItemKey, setNewItemKey] = useState();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const { removeImage } = useRemoveImage();
  const { updatePlateItems } = useUpdatePlateItems();

  const onAddClicked = () => {
    let cloned_plates = JSON.parse(JSON.stringify(plates));
    let new_item_key = _.uniqueId("item-");

    cloned_plates[selectedPlateIndex].items.push({
      key: new_item_key,
      category_id: null,
      category: "",
      sub_category: "",
      unit_price: 0,
      quantity: 1,
    });

    setPlates(cloned_plates);
    setSelectedItemKey(new_item_key);
    setNewItemKey(new_item_key);
    setActiveTabKey(2);
  };

  const onPreviousClicked = () => {
    setSelectedPlateIndex((prevSelectedPlateIndex) => {
      let newSelectedplateIndex = null;

      if (prevSelectedPlateIndex >= 1) {
        newSelectedplateIndex = prevSelectedPlateIndex - 1;
      } else {
        newSelectedplateIndex = prevSelectedPlateIndex;
      }

      setSelectedItemKey(null);
      return newSelectedplateIndex;
    });
  };

  const onNextClicked = () => {
    setSelectedPlateIndex((prevSelectedPlateIndex) => {
      let newSelectedplateIndex = null;

      if (prevSelectedPlateIndex + 1 <= plates.length - 1) {
        newSelectedplateIndex = prevSelectedPlateIndex + 1;
      } else {
        newSelectedplateIndex = prevSelectedPlateIndex;
      }

      setSelectedItemKey(null);
      return newSelectedplateIndex;
    });
  };

  const onCancelOrderClicked = () => {
    //Set image as Removed
    cancelOrder();
    setIsDisableButton((prev) => ({
      ...prev,
      delete_plate_btn: false,
      add_plate_btn: false,
      add_item_btn: false,
      takeaway_checkbox: false,
      delete_item_btn: false,
    }));
    setPlates([]);
    setSelectedPlateIndex(0);
    setSelectedItemKey(null);
    setIsShowPayment(false);
    setActiveTabKey(1);
  };

  const onPayClicked = () => {
    //Function to expand all row when "Pay" was clicked, bug exist and need to be fixed, function not ready to use
    // setExpandedRowKeys(plates[selectedPlateIndex].items.map((r)=>{
    //   if(r.sub_category.length > 0){
    //     return r.key
    //   }
    // }))
    updatePlateItems(plates, setPlates, setSelectedItemKey);
    setIsDisableButton((prev) => ({
      ...prev,
      delete_plate_btn: true,
      add_plate_btn: true,
      add_item_btn: true,
      takeaway_checkbox: true,
      delete_item_btn: true,
    }));
    setIsShowPayment(true);
  };

  const onDeletePlateClicked = () => {
    //Set image as Removed
    let cloned_plates = JSON.parse(JSON.stringify(plates));

    if (selectedPlateIndex > -1 && selectedPlateIndex < cloned_plates.length) {
      removeImage(cloned_plates[selectedPlateIndex].image_id);
      cloned_plates.splice(selectedPlateIndex, 1);
      setPlates(cloned_plates);
      setSelectedPlateIndex((prevSelectedPlateIndex) => {
        let newSelectedplateIndex = null;

        if (
          prevSelectedPlateIndex <= cloned_plates.length &&
          prevSelectedPlateIndex != 0
        ) {
          newSelectedplateIndex = prevSelectedPlateIndex - 1;
        } else {
          newSelectedplateIndex = prevSelectedPlateIndex;
          setActiveTabKey(1);
        }

        return newSelectedplateIndex;
      });
    }
  };

  const onAddPlateClicked = () => {
    let cloned_plates = JSON.parse(JSON.stringify(plates));

    if (
      plates[plates.length - 1]?.image_id != null &&
      plates[plates.length - 1]?.ai_image_data != null
    ) {
      cloned_plates.push(PLATE);
      setPlates(cloned_plates);
      setSelectedPlateIndex(plates.length);
      setActiveTabKey(1);
    }
  };

  function handleScrollToRow(key) {
    const rowElement = tableRef.current.querySelector(
      `tr[data-row-key="${key}"]`
    );

    if (rowElement) {
      rowElement.scrollIntoView({ behavior: "instant", block: "nearest" });
    }
  }

  function cancelOrder() {
    let image_ids = plates.map((item) => item.image_id);
    removeImage(image_ids);
    setExtraChargesOptions((prev) => ({
      ...prev,
      takeaway_fee: false,
    }));
  }

  const onTakeawayChange = (e) => {
    setExtraChargesOptions((prev) => ({
      ...prev,
      takeaway_fee: e.target.checked,
    }));
  };

  useEffect(() => {
    if (itemDetailsCardRef.current) {
      setTableRefState(true);
    }
  }, [itemDetailsCardRef]);

  useEffect(() => {
    if (plates.length == 0 || plates[0]?.image_id == null) {
      setIsDisableButton((prev) =>
        Object.fromEntries(Object.keys(prev).map((key) => [key, true]))
      );
    }
  }, [plates]);

  useEffect(() => {
    if (newItemKey) {
      handleScrollToRow(newItemKey);
      if (newItemKey.length > 0) {
        setExpandedRowKeys([newItemKey]);
      }
      setNewItemKey(null);
    }
  }, [newItemKey]);

  useEffect(() => {
    setNewItemKey(selectedItemKey);
  }, [selectedItemKey]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            cellFontSizeSM: 12,
          },
        },
      }}
    >
      <Card
        style={{ height: "100%" }}
        styles={{ body: { height: "100%", padding: 0 } }}
        // title="Items"
        // extra={
        //   <Button
        //     type="primary"
        //     onClick={onAddClicked}
        //     disabled={
        //       selectedPlateIndex == null ||
        //       isDisableButton.add_item_btn ||
        //       plates[selectedPlateIndex]?.image_id == null
        //     }
        //     style={{ fontWeight: "bold" }}
        //   >
        //     Add
        //   </Button>
        // }
      >
        <div style={{ height: "100%" }}>
          <Flex justify="space-between" vertical style={{ height: "100%" }}>
            {tableRefState ? (
              <div ref={tableRef}>
                <ItemsTable
                  plates={plates}
                  setPlates={setPlates}
                  tableRef={itemDetailsCardRef}
                  filterRef={gridRef}
                  tableHeightOffset={38}
                  selectedPlateIndex={selectedPlateIndex}
                  setActiveTabKey={setActiveTabKey}
                  selectedItemKey={selectedItemKey}
                  setSelectedItemKey={setSelectedItemKey}
                  expandedRowKeys={expandedRowKeys}
                  setExpandedRowKeys={setExpandedRowKeys}
                  isDisableButton={isDisableButton}
                  setSelectedSubCategory={setSelectedSubCategory}
                />
              </div>
            ) : (
              <></>
            )}
            <Card.Grid style={{ width: "100%", padding: 0 }}>
              <div ref={gridRef} style={{ width: "100%", padding: 10 }}>
                {/* <Flex justify="space-between" align="center">
                  <Button onClick={onPreviousClicked}>Previous</Button>
                  {plates.length > 0 && selectedPlateIndex != null
                    ? selectedPlateIndex + 1 + "/" + plates.length
                    : "/"}
                  <Button onClick={onNextClicked}>Next</Button>
                </Flex> */}
                {/* <Flex justify="space-between" align="center">
                  <Flex gap={"small"}>
                    <Checkbox
                      disabled={isDisableButton.takeaway_checkbox}
                      checked={extraChangesOptions?.takeaway_fee}
                      onChange={onTakeawayChange}
                      style={{ fontWeight: "bold", fontSize: "1.2vw" }}
                    >
                      Takeaway:
                    </Checkbox>
                  </Flex>
                  <p className="price-summary-text">
                    RM{" "}
                    {extraChangesOptions.takeaway_fee
                      ? formatCurrency(extraCharges?.takeaway_fee)
                      : formatCurrency(0)}
                  </p>
                </Flex> */}
                <Flex justify="space-between" align="center">
                  <p className="price-summary-title">Subtotal:</p>
                  <p className="price-summary-text">
                    RM {formatCurrency(receiptPrice.subtotal)}
                  </p>
                </Flex>
                {sstInfo?.sst_enabled && (
                  <Flex justify="space-between" align="center">
                    <p className="price-summary-title">
                      SST-{sstInfo.sst_type == "Exclusive"? "excl":"incl"} ({sstInfo?.sst_rate}%):
                    </p>
                    <p className="price-summary-text">
                      RM {formatCurrency(receiptPrice.sst)}
                    </p>
                  </Flex>
                )}
                {receiptPrice.round_adj !== null &&
                  receiptPrice.round_adj !== 0 && (
                    <Flex justify="space-between" align="center">
                      <p className="price-summary-title">Round Adj:</p>
                      <p className="price-summary-text">
                        RM {formatCurrency(receiptPrice.round_adj)}
                      </p>
                    </Flex>
                  )}

                {receiptPrice.cash != null && (
                  <Flex justify="space-between" align="center">
                    <p className="price-summary-title">Cash:</p>
                    <p className="price-summary-text">
                      RM {formatCurrency(receiptPrice.cash)}
                    </p>
                  </Flex>
                )}
                {receiptPrice.change != null && (
                  <Flex justify="space-between" align="center">
                    <p
                      className="price-summary-title"
                      style={{ color: "#1677ff" }}
                    >
                      Change:
                    </p>
                    <p
                      className="price-summary-text"
                      style={{ color: "#1677ff" }}
                    >
                      RM {formatCurrency(receiptPrice.change)}
                    </p>
                  </Flex>
                )}
                <Flex justify="space-between" align="center">
                  <p
                    className="price-summary-title"
                    style={{
                      fontSize: "2.3vw",
                    }}
                  >
                    Total:
                  </p>
                  <p
                    className="price-summary-text"
                    style={{ fontSize: "2.8vw" }}
                  >
                    RM {formatCurrency(receiptPrice.total)}
                  </p>
                </Flex>
                <Row gutter={[4, 4]}>
                  <Col span={12}>
                    <Button
                      className="summary-btn"
                      style={{ background: "#FF4D4F" }}
                      onClick={onCancelOrderClicked}
                      disabled={isDisableButton.cancel_order_btn}
                      block
                    >
                      Cancel Order
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      className="summary-btn"
                      style={{ background: "#38B865" }}
                      onClick={onPayClicked}
                      disabled={isDisableButton.pay_btn}
                      block
                    >
                      Pay
                    </Button>
                  </Col>
                  {/* <Col span={12}>
                    <Button
                      className="summary-btn"
                      style={{ background: "#FF4D4F" }}
                      onClick={onDeletePlateClicked}
                      disabled={isDisableButton.delete_plate_btn}
                      block
                    >
                      Delete Plate
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      className="summary-btn"
                      style={{ background: "#1677FF" }}
                      onClick={onAddPlateClicked}
                      disabled={isDisableButton.add_plate_btn}
                      block
                    >
                      Add Plate
                    </Button>
                  </Col> */}
                </Row>
              </div>
            </Card.Grid>
          </Flex>
        </div>
      </Card>
    </ConfigProvider>
  );
}
